import { generateAemConfiguration } from '@as-react/common-utils';
import { Logger } from '@as-react/logger';
import { createDynamicModuleLoaderAnalyticsAdobeTagManager } from '../middleware/analyticsAdobeTagManagerMiddlewareBuilder';
import { createDynamicModuleLoaderAnalyticsCriteo } from '../middleware/analyticsCriteoMiddlewareBuilder';
import { createDynamicModuleLoaderAnalyticsGoogleTagManager } from '../middleware/analyticsGoogleTagManagerMiddlewareBuilder';
import createDynamicModuleLoaderCustomEvent from '../middleware/customEventMiddlewareBuilder';
import { createDynamicModuleLoaderRouterMiddleWare } from '../middleware/routerMiddlewareBuilder';
import loadRouterModule from '../rootModules/modules/Router.module';
import { createDynamicReduxStore, createSagaExtension } from '../store/DynamicReduxStore';
export const configureDynamicStoreBase = (initialState, context, dynamicStore, componentReduxModules, history, composeEnhancers) => {
    if (!dynamicStore.getStore()) {
        if (context.aemConfiguration) {
            context.aemConfiguration = generateAemConfiguration(context.aemConfiguration);
        }
        dynamicStore.setStore(createDynamicReduxStore({
            initialState: initialState,
            extensions: [createSagaExtension(context)],
            enhancers: Logger.reduxEnhancer ? [Logger.reduxEnhancer] : undefined,
            advancedComposeEnhancers: composeEnhancers,
        }, 
        /* Custom compose */
        createDynamicModuleLoaderAnalyticsAdobeTagManager(), createDynamicModuleLoaderAnalyticsCriteo(), createDynamicModuleLoaderAnalyticsGoogleTagManager(), createDynamicModuleLoaderCustomEvent()));
    }
    if (componentReduxModules) {
        if (Array.isArray(componentReduxModules)) {
            dynamicStore.getStore().addModules(componentReduxModules);
        }
        else {
            dynamicStore.getStore().addModule(componentReduxModules);
        }
    }
    if (history) {
        dynamicStore.getStore().addModules([loadRouterModule(history), createDynamicModuleLoaderRouterMiddleWare(history)]);
    }
    return dynamicStore.getStore();
};
